import { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import {
  FirebaseAuthService,
  useMutate,
} from '@kanda-libs/ks-frontend-services';

import { URLS } from 'common/constants';

export type LogoutHook = () => void;

function useLogout(automaticallyLogout = true): LogoutHook {
  const { push } = useHistory();
  const { mutate: logout } = useMutate(FirebaseAuthService.logout);

  const handleLogout = useCallback(() => {
    logout(false);
    push(URLS.login);
  }, [logout]);

  useEffect(() => {
    if (!automaticallyLogout) return;
    handleLogout();
  }, [logout]);

  return handleLogout;
}

export default useLogout;
